import type { SVGProps } from 'react'
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0F141E"
      fillRule="evenodd"
      d="M7.002 11.1a.9.9 0 1 0 0 1.8h4.1v4.104a.9.9 0 0 0 1.8 0V12.9h4.1a.9.9 0 0 0 0-1.8h-4.1V7.004a.9.9 0 1 0-1.8 0V11.1z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCross
